import { ShopTypeEnum } from '../components/ShopeeCNSCGuide';

export const deriveShopType = (
  storeType: IM_API.Admin.StoreType,
  region: General.UpperCaseRegion | 'CNSC',
): ShopTypeEnum => {
  if (storeType === 'LOCAL') {
    return ShopTypeEnum.Local;
  }
  return region === 'CNSC' ? ShopTypeEnum.CrossOfficial : ShopTypeEnum.Cross3PF;
};
